import { render, staticRenderFns } from "./PassReset.vue?vue&type=template&id=3ff683db&scoped=true"
import script from "./PassReset.vue?vue&type=script&lang=js"
export * from "./PassReset.vue?vue&type=script&lang=js"
import style0 from "./PassReset.vue?vue&type=style&index=0&id=3ff683db&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff683db",
  null
  
)

export default component.exports